export var getPropertyTypeWithDot = function getPropertyTypeWithDot(ratingNumber, propertyType) {
  return ratingNumber >= 1 ? "\xB7 ".concat(propertyType) : propertyType;
};